import React, { useEffect } from 'react'
import View from './view.js'
import useOnClickOutside from 'use-onclickoutside'
import { normalizePath, useFlowValue, useSetFlowTo } from 'Simple/Flow.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { useFloating, offset } from '@floating-ui/react-dom'

export default function Logic(props) {
  let flow = useFlowValue(normalizePath(props.viewPath, 'Launchers'))
  let refetch = useDataValue({
    context: 'global',
    path: 'refresh_apps_launchers',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'apps',
    viewPath: props.viewPath,
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  let { refs, x, y } = useFloating({
    open: flow === 'Content',
    middleware: [offset({ mainAxis: 10 })],
  })

  useOnClickOutside(refs.floating, event => {
    if (
      event.target === refs.reference.current ||
      refs.reference.current?.contains(event.target) ||
      event.target.dataset.viewPath?.includes('AssignConnection')
    ) {
      return
    }

    setFlowTo(normalizePath(props.viewPath, 'Launchers/No'))
  })

  useEffect(() => {
    if (!refetch) return

    submit({ type: 'reFetch' })
  }, [refetch]) // eslint-disable-line react-hooks/exhaustive-deps
  // ignore submit

  return (
    <View
      {...props}
      setOuterRef={refs.setReference}
      setInnerRef={refs.setFloating}
      left={x}
      top={y}
    />
  )
}
